import type { ReactNode } from 'react';

import type { ChartColor } from './chartColors';

/** One data row; the index key holds the x-axis label and every other key is a series. */
export type ChartDatum = Record<
  string,
  string | number | boolean | null | undefined
>;

/** Datum key flagging a month after the books-closed date; drawn dashed/faded. */
export const PRELIMINARY_KEY = 'preliminary';

export type ChartValueFormatter = (value: number) => string;

export interface IChartTooltipEntry {
  category: string;
  value: number;
  color: ChartColor;
  /** Pre-formatted value; takes precedence over the tooltip's `valueFormatter`. */
  formattedValue?: string;
}

export interface IChartTooltipProps {
  active: boolean | undefined;
  label: string;
  payload: IChartTooltipEntry[];
  valueFormatter: ChartValueFormatter;
  /** The hovered datum is a month after the books-closed date. */
  preliminary?: boolean;
}

export type ChartTooltipRenderer = (props: IChartTooltipProps) => ReactNode;

export interface IBaseChartProps {
  data: ChartDatum[];
  /** Key in each datum used for the x-axis. */
  index: string;
  categories: string[];
  colors?: ChartColor[];
  valueFormatter?: ChartValueFormatter;
  showLegend?: boolean;
  showGridLines?: boolean;
  showXAxis?: boolean;
  showYAxis?: boolean;
  /** Label only the first, last and up to four evenly spaced x values. */
  sparseXLabels?: boolean;
  yAxisWidth?: number;
  autoMinValue?: boolean;
  minValue?: number;
  maxValue?: number;
  customTooltip?: ChartTooltipRenderer;
  className?: string;
}
